import { SvgIcon, type SvgIconProps } from '@mui/material';
import React from 'react';

function CalendarIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M4.42072 8.25H6.54545V10.3125H4.42072V8.25Z" fill="black" />
      <path d="M6.54545 11.25H4.5V13.3125H6.54545V11.25Z" fill="black" />
      <path d="M10.0227 8.25H7.89799V10.3125H10.0227V8.25Z" fill="black" />
      <path d="M10.0227 11.25H7.89799V13.3125H10.0227V11.25Z" fill="black" />
      <path d="M13.5 8.25H11.3753V10.3125H13.5V8.25Z" fill="black" />
      <path d="M13.5 11.25H11.3753V13.3125H13.5V11.25Z" fill="black" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 1.875C4.5 1.66789 4.66789 1.5 4.875 1.5H6.75C6.95711 1.5 7.125 1.66789 7.125 1.875V3H10.875V1.875C10.875 1.66789 11.0429 1.5 11.25 1.5H13.125C13.3321 1.5 13.5 1.66789 13.5 1.875V3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V15.75C16.5 16.1642 16.1642 16.5 15.75 16.5H2.25C1.83579 16.5 1.5 16.1642 1.5 15.75V3.75C1.5 3.33579 1.83579 3 2.25 3H4.5V1.875ZM14.625 6.9375H3.375V14.625H14.625V6.9375Z"
        fill="black"
      />
    </SvgIcon>
  );
}

export default CalendarIcon;
